exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".template-modal .modal-header h4,\n.template-modal .modal-title {\n  font-size: 2em;\n}\n", ""]);

// exports
